module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timer-wrapper"
  }, [_c('div', {
    staticClass: "time"
  }, [_c('div', {
    staticClass: "countdown",
    attrs: {
      "id": "countdown"
    }
  }, [_c('span', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(String(_vm.h).length >= 2 ? _vm.h : '0' + _vm.h))]), _vm._v(" "), _c('div', [_vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "minutes"
  }, [_vm._v(_vm._s(String(_vm.m).length >= 2 ? _vm.m : '0' + _vm.m))]), _vm._v(" "), _c('div', [_vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "seconds"
  }, [_vm._v(_vm._s(String(_vm.s).length >= 2 ? _vm.s : '0' + _vm.s))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f36434c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home-page/specialOffers/counter.vue
// module id = 1602
// module chunks = 1